import { render } from "./TaskToDetail.vue?vue&type=template&id=e313a3a4"
import script from "./TaskToDetail.vue?vue&type=script&lang=js"
export * from "./TaskToDetail.vue?vue&type=script&lang=js"

import "./TaskToDetail.vue?vue&type=style&index=0&id=e313a3a4&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__